import { ref, computed } from 'vue';
import { SelectOption } from '../../../select/types';
import { TableSlots } from '../MeridiaTable';

export function useColumns<T>(slots: TableSlots<T>) {
  const hiddenColumns = ref<SelectOption[]>([]);

  const columnGroups = computed(() => {
    return slots.columnGroups?.();
  });

  const columnsSlots = computed(() => {
    return slots
      .default?.()
      .filter((slot) => (slot.type as any).name === 'Column');
  });

  const columnsOptions = computed(() => {
    return columnsSlots.value
      .filter((slot) => slot.props?.header && slot.props?.field)
      .map((slot) => {
        return {
          label: slot.props?.header,
          value: slot.props?.field,
        };
      });
  });

  const columns = computed(() => {
    return (
      columnsSlots.value.filter(
        (column) =>
          (column.props?.field || Object.hasOwn(column.props, 'expander')) &&
          !hiddenColumns.value?.some(
            (hidden) => hidden.value === column.props.field
          ) &&
          !column.props.hidden
      ) || []
    );
  });

  /**
   * Calculates the actual column span for a column group based on visibility of columns
   * @param {number} index - The index of the column group
   * @returns {number} The calculated column span accounting for hidden columns
   */
  function getCurrentColumnSpanOfGroup(index: number) {
    const originalColSpan = columnGroups.value[index]?.props?.colspan;

    if (!originalColSpan) {
      return columns.value.length / columnGroups.value.length;
    }

    let startColumnIndex = 0;
    for (let i = 0; i < index; i++) {
      startColumnIndex += columnGroups.value[i]?.props?.colspan || 0;
    }

    const endColumnIndex = startColumnIndex + originalColSpan;
    let visibleColumnsInRange = 0;
    const originalColumnsSlots = columnsSlots.value;

    for (
      let i = startColumnIndex;
      i < endColumnIndex && i < originalColumnsSlots.length;
      i++
    ) {
      const column = originalColumnsSlots[i];
      if (
        column.props?.field &&
        !hiddenColumns.value?.some(
          (hidden) => hidden.value === column.props.field
        ) &&
        !column.props.hidden
      ) {
        visibleColumnsInRange++;
      }
    }

    return visibleColumnsInRange;
  }

  return {
    hiddenColumns,
    columnsOptions,
    columns,
    columnGroups,
    getCurrentColumnSpanOfGroup,
  };
}
